import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class URLService {
  constructor() {}

  getQueryParamByKey(key: string): string {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams) {
      return "";
    }

    const param = urlParams.get(key);
    return param || "";
  }

  getRedirectWithCurrentQuery(basePath: string): string {
    return `/${basePath}${window.location.search}`;
  }
}
